import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

type SupportDeskPaneCollapseButtonProps = {
  collapsed: boolean;
  side: 'start' | 'end';
  collapseLabel: string;
  expandLabel: string;
  onToggle: () => void;
};

export function SupportDeskPaneCollapseButton({
  collapsed,
  side,
  collapseLabel,
  expandLabel,
  onToggle,
}: SupportDeskPaneCollapseButtonProps) {
  const label = collapsed ? expandLabel : collapseLabel;
  const showRightChevron =
    (side === 'start' && collapsed) || (side === 'end' && !collapsed);

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      aria-expanded={!collapsed}
      onClick={onToggle}
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-secondary-500 transition-colors hover:bg-secondary-100 hover:text-secondary-800"
    >
      {showRightChevron ? (
        <ChevronRightIcon className="h-4 w-4" aria-hidden="true" />
      ) : (
        <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
